import { CSSProperties, FC, ReactNode } from "react";
import { Box, createStyles, makeStyles } from "@material-ui/core";

import theme from "theme";

const baseTagStyles: CSSProperties = {
  color: theme.custom.palette.black.main,
  borderRadius: theme.shape.borderRadius,
  borderWidth: "2px",
  borderStyle: "solid",
  backgroundColor: theme.palette.background.default,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: "0.7rem",
  padding: "5px",
  textAlign: "center",
};

const colorStyles: Record<ColorOptions, CSSProperties> = {
  green: {
    color: theme.custom.palette.green.main,
    borderColor: theme.custom.palette.green.main,
  },
  yellow: {
    color: theme.custom.palette.yellow.main,
    borderColor: theme.custom.palette.yellow.main,
  },
  red: {
    color: theme.custom.palette.red.main,
    borderColor: theme.custom.palette.red.main,
  },
};

export type ColorOptions = "green" | "yellow" | "red";

type StyleProps = {
  color: ColorOptions;
};

type TagProps = StyleProps & {
  children: ReactNode;
  dataTestId?: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    tag: (props: StyleProps) => ({
      ...baseTagStyles,
      ...colorStyles[props.color],
    }),
  }),
);

const Tag: FC<TagProps> = ({ color, children, dataTestId }) => {
  const classes = useStyles({ color });
  return (
    <Box className={classes.tag} data-testid={dataTestId}>
      {children}
    </Box>
  );
};

export default Tag;
